(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    const params = new URLSearchParams(window.location.search);
    root.querySelectorAll('.sb-contact-form:not([data-context-ready])').forEach(form => {
      if (!form.querySelector('[data-sb-context]')) return;
      form.dataset.contextReady = 'true';
      for (const [param, name] of [['subject', 'Subject'], ['vehicle', 'Vehicle']]) {
        const field = form.elements.namedItem(`contact[${name}]`);
        if (field && !field.value) field.value = (params.get(param) || '').slice(0, field.maxLength > 0 ? field.maxLength : 200);
      }
      const context = (params.get('context') || params.get('product') || '').slice(0, 500);
      form.querySelector('[data-sb-context]').value = context;
      const label = form.querySelector('[data-sb-context-label]');
      label.textContent = context; label.hidden = !context;
    });
    const packages = [...document.querySelectorAll('[data-sb-package]')];
    function selectPackage(id, scroll) {
      packages.forEach(panel => { panel.hidden = panel.dataset.sbPackage !== id; });
      document.querySelectorAll('[data-sb-pick]').forEach(link => link.setAttribute('aria-pressed', String(link.dataset.sbPick === id)));
      if (scroll) document.getElementById('packages-' + id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (packages.length) selectPackage(packages[0].dataset.sbPackage, false);
    root.querySelectorAll('[data-sb-pick]:not([data-ready])').forEach(link => {
      link.dataset.ready = 'true';
      link.addEventListener('click', event => { event.preventDefault(); selectPackage(link.dataset.sbPick, true); });
    });
    root.querySelectorAll('[data-sb-finder]:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const vehicles = JSON.parse(form.querySelector('[data-sb-vehicles]').textContent);
      const make = form.elements.make, model = form.elements.model;
      const button = form.querySelector('button');
      const placeholder = model.options[0].textContent;
      make.addEventListener('change', () => {
        model.replaceChildren(new Option(placeholder, ''));
        vehicles.filter(vehicle => vehicle.make === make.value).forEach(vehicle => model.add(new Option(vehicle.name, vehicle.url)));
        model.disabled = !make.value;
        button.disabled = true;
      });
      model.addEventListener('change', () => { button.disabled = !model.value; });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (form.reportValidity() && vehicles.some(vehicle => vehicle.url === model.value)) window.location.assign(model.value);
      });
    });
    root.querySelectorAll('[data-sb-enquiry="build"]:not([data-ready])').forEach(wizard => {
      wizard.dataset.ready = 'true';
      const steps = [...wizard.querySelectorAll('[data-sb-step]')];
      const back = wizard.querySelector('[data-sb-back]'), next = wizard.querySelector('[data-sb-next]'), submit = wizard.querySelector('[data-sb-submit]');
      let current = 0;
      function show(index, focus = true) {
        current = index;
        steps.forEach((step, i) => { step.hidden = i !== current; });
        back.hidden = current === 0;
        next.hidden = current === steps.length - 1;
        submit.hidden = current !== steps.length - 1;
        if (focus) {
          const legend = steps[current].querySelector('legend');
          legend.tabIndex = -1;
          legend.focus();
        }
      }
      function advance() {
        const invalid = [...steps[current].querySelectorAll('input,select,textarea')].find(field => !field.checkValidity());
        if (invalid) invalid.reportValidity();
        else show(Math.min(current + 1, steps.length - 1));
      }
      back.addEventListener('click', () => show(Math.max(0, current - 1)));
      next.addEventListener('click', advance);
      wizard.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.matches('input:not([type="checkbox"])') && current < steps.length - 1) {
          event.preventDefault(); advance();
        }
      });
      wizard.closest('form').addEventListener('invalid', event => {
        const index = steps.findIndex(step => step.contains(event.target));
        if (index >= 0 && index !== current) show(index, false);
      }, true);
      show(0, false);
    });
    root.querySelectorAll('.sb-success, .sb-error').forEach(message => message.focus());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:cart:lines-update', event => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (Number.isInteger(count)) document.querySelectorAll('[data-sb-cart-count]').forEach(element => { element.textContent = String(count); });
    }).catch(() => {});
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sb-nav-group[open],.sb-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.sb-desktop-nav .sb-nav-group[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
